module.exports = __webpack_public_path__ + "static/SailPoint-6735ed76e17950efa3793693eb3698f1.jpg";